import { SCREENS, useMediaQuery } from '@repo/common';

/**
 * 괄호 예시 제거. 영어 `(e.g. …)` 와 한국어 `(예: …)` 모두 지원하며,
 * 패턴이 없으면 원문을 그대로 돌려준다.
 */
export const stripExample = (text = '') =>
  String(text)
    .replace(/\s*\(\s*e\.g\.[^)]*\)/gi, '')
    .replace(/\s*\(\s*예\s*[:：][^)]*\)/g, '')
    .trim();

/**
 * 모바일용 짧은 플레이스홀더.
 * - 'Select …' → 'Select'
 * - '…을/를 선택하세요' / '…을/를 선택해 주세요' → '선택'
 * - 그 외에는 원문 그대로.
 */
export const shortenSelect = (text = '') => {
  const value = String(text);
  if (/^select\s+\S/i.test(value)) return 'Select';
  if (/선택(하세요|해\s?주세요)\s*$/.test(value)) return '선택';
  return value;
};

const usePlaceholder = () => {
  const isMobile = useMediaQuery(`(max-width: ${SCREENS.tabletH - 0.02}px)`);
  return (text) => (isMobile ? shortenSelect(stripExample(text)) : text);
};

export default usePlaceholder;
